// extracted by mini-css-extract-plugin
export default {"success":"LimaToast_success__m3hY6","error":"LimaToast_error__ItHkY","warning":"LimaToast_warning__CguNt"};